// i18next-extract-mark-ns-start CoutureServices
import React from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { slashNtoBr } from '../services/formatting';
import {
  tabletThresholdPixels, colors, Button, frames, mobileThresholdPixels,
} from './home/v4/styledComponents';
import CTALink from './CTALink';

const Container = styled.div`
  width: 100%;
  position: relative;
`;

const Img = styled.img`
  width: 100%;
  max-height: 693px;
  min-height: 476px;
  object-fit: cover;
  object-position: center bottom;
  @media (max-width: ${tabletThresholdPixels}) {
    height: 868px;
    max-height: 868px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    height: unset;
    max-height: 693px;
  }
`;

const OverlayBanner = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  color: ${colors.beige100};
  text-align: start;
  margin: 0 0 0 ${frames.desktop};
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 0 0 ${frames.tablet};
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: 0;
    width: calc(100vw - 100px);
    left: 45%;
  }
`;

const Title = styled.h1`
font-size: 48px;
font-weight: 700;
text-transform: uppercase;
margin: 0;
@media (max-width: ${mobileThresholdPixels}) {
  font-size: 20px;
  font-weight: 400;
  width: unset;
}
`;

const Subtitle = styled.h2`
font-size: 48px;
font-weight: 200;
text-transform: uppercase;
margin: 0;
@media (max-width: ${mobileThresholdPixels}) {
  font-size: 32px;
  font-weight: 400;
  width: unset;
}
`;

const Text = styled.p`
  font-size: 16px;
  width: 526px;
  font-weight: 400;
  margin: 8px 0 32px;
  @media (max-width: ${mobileThresholdPixels}) {
    width: 100%;
    margin: 8px 0 24px;
    font-size: 14px;
  }
`;

interface HeaderBannerProps {
  image: string;
  title: string;
  text?: string;
  buttonText: string;
  url?: string | null;
  noButton?: boolean;
  preFilledSteps?: any;
  subtitle?: string;
  setSignUpPopup?: (_value: boolean) => void;
}

function HeaderBanner({
  image, title, text, buttonText, url, noButton, preFilledSteps, subtitle, setSignUpPopup,
}: HeaderBannerProps) {
  const { t } = useTranslation();
  return (
    <Container>
      <Img src={image} alt="Bannière Join the cycle" />
      <OverlayBanner>
        <Title>{slashNtoBr(title)}</Title>
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
        <Text>{text}</Text>
        {!noButton && !url && (
          setSignUpPopup
            ? (
              <Button dark onClick={() => setSignUpPopup(true)}>{t(buttonText)}</Button>
            ) : (
              <CTALink
                fromInteraction="HeaderBanner"
                linkState={preFilledSteps}
              >
                <Button dark>{buttonText ? t(buttonText) : t('Prendre RDV')}</Button>
              </CTALink>
            )
        )}
        {!noButton && url && <Button dark onClick={() => navigate(url)}>{buttonText ? t(buttonText) : t('Prendre RDV')}</Button>}
      </OverlayBanner>
    </Container>
  );
}

HeaderBanner.defaultProps = {
  noButton: false,
  preFilledSteps: null,
  subtitle: '',
  setSignUpPopup: null,
  url: null,
  text: '',
};

export default HeaderBanner;
